module.exports = __webpack_public_path__ + "img/smartoplogo.e88ec1fe.png";